import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { PartialWithRequired } from './utils';

export const upsellBpContextName = 'upsell_context';
export const upsellBpContextSchemaVersion = 4;
export type UpsellBpContext = Fields<
  typeof upsellBpContextName,
  typeof upsellBpContextSchemaVersion
>;

export type UpsellBpContextFields = PartialWithRequired<
  UpsellBpContext,
  'upsell_feature_category' | 'upsell_specific_feature' | 'upsell_badge_location'
>;

export const buildUpsellBpContext = (fields: UpsellBpContextFields) => {
  return {
    upsell_context: new EventContext(upsellBpContextName, upsellBpContextSchemaVersion, fields),
  };
};
